<template>
  <div class="comp-container">
    <div class="title">
      <img src="@saas/pages/assets/images/live-data/income.png" alt="" />
      <p>直播收益</p>
    </div>
    <div class="comp-content">
      <div class="live-income">
        <!-- <img
          src="@saas/pages/assets/images/live-data/income-title.png"
          alt=""
        /> -->
        <p v-if="liveReport.sell_course_duration === 0" class="tips">
          在直播中使用课程售卖功能后可产生直播收益
        </p>
        <div v-else>
          <ul class="data-wrap">
            <li class="data-item" style="width: 154px; padding-left: 20px">
              <p class="data">{{ liveReport.sell_course_num }}</p>
              <p class="data-name">上架课程数量</p>
            </li>
            <li class="data-item center" style="width: 173px">
              <div>
                <p class="data duration-time">
                  {{ handleSellDuration }}
                </p>
                <p class="data-name">课程上架时长</p>
              </div>
            </li>
            <li class="data-item">
              <p class="data">{{ liveReport.sell_course_click_num }}</p>
              <p class="data-name">链接点击次数</p>
            </li>
          </ul>
          <ul class="data-wrap sell-data-wrap">
            <li class="data-item" style="width: 154px; padding-left: 20px">
              <p class="data course-name">
                {{ liveReport.sell_max_earnings_goods_name || "无" }}
              </p>
              <p class="data-name">收益最高商品</p>
            </li>
            <li class="data-item center" style="width: 173px">
              <div>
                <p class="data course-name">
                  {{ liveReport.sell_max_goods_name || "无" }}
                </p>
                <p class="data-name">售出最多商品</p>
              </div>
            </li>
            <li class="data-item">
              <p class="data sell-amount" v-html="handleSellTotalAmount"></p>
              <p class="data-name">本场直播收入</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    liveReport: {
      typeof: Object,
      default: () => {},
    },
  },
  data() {
    return {
      myChart: null,
      dialogType: "attend", // attend 出勤 absent缺席
      dialogVisible: false,
      currentPage: 1,
      pageSize: 10,
      totalPages: 5,
      tableData: [],
      preThreeData: [],
    };
  },
  watch: {
    liveReport: {
      handler(val) {
        console.log(777);
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    handleSellTotalAmount() {
      let [integer, decimal] = (this.liveReport.sell_total_amount / 100)
        .toFixed(2)
        .split(".");
      return `<span class="symbol">￥</span><span class="integer">${integer}</span><span class="decimal">.${decimal}</span>`;
    },
    handleSellDuration() {
      let duration = this.liveReport.sell_course_duration;
      const hours = Math.floor(duration / 3600); // 计算小时
      const minutes = Math.floor((duration % 3600) / 60); // 计算分钟
      const second = Math.floor(duration % 60); // 计算秒
      let str = `${minutes < 10 ? "0" + minutes : minutes}:${
        second < 10 ? "0" + second : second
      }`;
      if (hours > 0) {
        str = `${hours}:` + str;
      }
      return str;
    },
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.comp-container {
  width: 590px;
  height: 274px;
  background: #ffffff;
  border-radius: 24px 24px 24px 24px;
  .title {
    display: flex;
    align-items: center;
    padding: 24px 0 0 24px;
    img {
      width: 24px;
      height: 24px;
    }
    p {
      flex: 1;
      font-weight: 500;
      font-size: 16px;
      color: #0d1400;
      margin-left: 8px;
    }
    .more-btn {
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 12px;
      color: #4e5969;
      margin-right: 24px;
      cursor: pointer;
      i {
        margin-left: 2px;
        font-size: 12px;
        color: #4e5969;
      }
    }
  }
  .comp-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-top: 8px;
    padding: 0 24px;
    .live-income {
      width: 100%;
      min-height: 76px;
      border-radius: 18px;
      padding: 12px 0 0;
      margin: 0 auto;
      img {
        width: 86px;
        height: 20px;
        margin-left: 18px;
      }
      .tips {
        margin-top: 10px;
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;
        padding-left: 22px;
      }
    }
    .data-wrap {
      display: flex;
    }
    .sell-data-wrap.data-wrap {
      padding-top: 30px;
    }
    .sell-data-wrap.data-wrap .data {
      height: 56px;
    }
    .data-item {
      padding: 0 0 0 36px;
      position: relative;
      .data.course-name {
        height: 56px;
        font-weight: 600;
        font-size: 20px;
        color: #0d1400;
        line-height: 28px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
      .data {
        font-weight: bold;
        font-size: 36px;
        color: #0d1400;
        line-height: 42px;
        margin-bottom: 8px;
      }
      ::v-deep .sell-amount {
        padding-top: 14px;
        font-weight: bold;
        color: #f03349;
        .symbol {
          font-weight: 600;
          font-size: 19px;
          line-height: 26px;
        }
        .integer {
          font-size: 36px;
          line-height: 42px;
        }
        .decimal {
          font-size: 24px;
          line-height: 28px;
        }
      }
      .data-name {
        font-weight: 400;
        font-size: 16px;
        color: #515350;
        line-height: 22px;
      }
      &::after {
        position: absolute;
        right: 0;
        top: 3px;
        display: block;
        content: "";
        width: 1px;
        height: 64px;
        background: linear-gradient(
          180deg,
          rgba(244, 244, 247, 0) 0%,
          #f2f2f5 14%,
          #e7e8ec 89%,
          rgba(229, 230, 235, 0) 100%
        );
      }
      &:last-child::after {
        display: none;
      }
      &.center {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0;
      }
    }
  }
}
</style>
